import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import withEnhancedStyleLoader from '../../hoc/withEnhancedStyleLoader/withEnhancedStyleLoader';
import useTranslation from '../../../hooks/useCustomTranslation';
import useEventListener from '../../../hooks/useEventListener';
import useLimitResize from '../../../hooks/useLimitResize';

import { st, classes } from './EditorWidgetContent.st.css';
import {
  Text,
  SectionNotification,
  TextTypography,
  SectionNotificationType,
  IconButton,
  IconButtonThemes,
  Spinner,
} from 'wix-ui-tpa';
import Select from 'wix-ui-icons-common/on-stage/Select';
import Info from 'wix-ui-icons-common/on-stage/Info';
import Alert from 'wix-ui-icons-common/on-stage/Alert';

import AdsLogo from '../AdsLogo/index';

// redux
import useSelector from '../../../hooks/useTypedSelector';
import {
  getInstance,
  getOrigCompId,
  getWixPublicData,
  isMobile,
  removeWixPublicData,
  resizeComponent,
  setWixPublicData,
} from '../../../services/wixServices';

import {
  selectLoadingStatus,
  selectStatusConnect,
  selectAdunitsList,
  selectAdUnitByCompId,
  getInitialData,
  disconnectAllAdsByCompIdAsync,
  selectLoadingUpdateStatus,
  selectIsMigrated,
  selectDimensions,
  setDimensions,
} from '../../../store/adunits/adunitsSlice';

import STATUS from '../../../enums/statusEnum';
import {
  DEFAULT_HEIGHT_PX,
  DEFAULT_WIDTH_PX,
  sectionNotificationsTypes,
} from '../../../constansts';
import { SelectedAdUnit } from '../../../types/AdUnitDto';
import { SettingsDataType } from '../../../types';
import useDispatch from '../../../hooks/useTypedDispatch';
import WIDGET_SIZE from '../../../enums/widgetSize';

declare global {
  interface Window {
    Wix: any;
  }
}

const EditorWidgetContent = () => {
  const { t } = useTranslation('widget');
  const [connctedAd, setConnctedAd] = useState<boolean>(false);
  const [selectedAdtriggered, setSelectedAdtriggered] =
    useState<boolean>(false);
  const [selectedAd, setSelectedAd] = useState<SelectedAdUnit | undefined>(
    undefined,
  );
  const responsiveDimention = useSelector(selectDimensions);

  const dispatch = useDispatch();
  const loadingStatus = useSelector(selectLoadingStatus);
  const loadingUpdateStatus = useSelector(selectLoadingUpdateStatus);
  const statusConnect = useSelector(selectStatusConnect);
  const adunits = useSelector(selectAdunitsList);
  const adUnitByCompId = useSelector(selectAdUnitByCompId);
  const isMigrated = useSelector(selectIsMigrated);

  const signedinstance = getInstance();
  const compId = getOrigCompId();
  const sectionNotificationsIcons: JSX.Element[] = [
    <Info width={32} height={32} />,
    <Alert width={32} height={32} />,
    <Select width={32} height={32} />,
  ];
  let isEditorX = false;
  window.Wix?.Styles?.getStyleParams((sp:any)=>{
     isEditorX = sp?.booleans?.responsive;
  });
  const statusType =
    statusConnect === STATUS.connected || isMigrated
      ? adUnitByCompId || connctedAd
        ? SectionNotificationType.success
        : adunits.length
        ? SectionNotificationType.alert
        : isMigrated
        ? SectionNotificationType.default
        : SectionNotificationType.alert
      : statusConnect === STATUS.inReview
      ? SectionNotificationType.alert
      : SectionNotificationType.default;

  useEffect(() => {

   getWixPublicData(`${compId}`, 'COMPONENT').then((data: any) => {
      console.log('getWixPublicData COMPONENT', data, data[compId]);
      dispatch(setDimensions(data[getOrigCompId()]));
    });
  }, []);

  useEffect(() => {
    if (loadingStatus === 'idle') {
        dispatch(getInitialData({ instance: signedinstance, compId }));
    } else if (
      loadingStatus === 'succeeded' &&
      loadingUpdateStatus !== 'pending'
    ) {
      const height = adUnitByCompId?.dimensions?.height;
      const width = adUnitByCompId?.dimensions?.width;
      isMobile()?resizeComponent(DEFAULT_WIDTH_PX, DEFAULT_HEIGHT_PX):
      !isEditorX && (!adUnitByCompId || adUnitByCompId?.size === WIDGET_SIZE.responsive)
                ? setTimeout(() => {
                    resizeComponent(
                      responsiveDimention.width,
                      responsiveDimention.height,
                    );
                  }, 500)
                :  adUnitByCompId?.size === WIDGET_SIZE.fixed && width &&
                  height &&
                  setTimeout(() => {
                    resizeComponent(width, height);
                  }, 500)

  }
    window.Wix.addEventListener(
      window.Wix.Events.SETTINGS_UPDATED,
      (data: SettingsDataType) => {
        if (compId === data.value.compId) {
          if (data.key === 'adSelected' || data.key === 'duplicate_ad') {
            console.log(
              'SETTINGS_UPDATED ',
              compId,
              data.value.compId,
              data,
              adUnitByCompId,
              responsiveDimention,
            );
            const height = data?.value?.selectedAd?.dimensions?.height;
            const width = data?.value?.selectedAd?.dimensions?.width;

            setConnctedAd(true);
            setSelectedAdtriggered(true);
            setSelectedAd(data?.value?.selectedAd);
            data?.value?.selectedAd?.size === WIDGET_SIZE.responsive &&
            data.key === 'adSelected'
              ? resizeComponent(
                  responsiveDimention.width,
                  responsiveDimention.height,
                )
              : resizeComponent(width, height);

            data?.value?.selectedAd?.size === WIDGET_SIZE.fixed &&
              width &&
              height &&
              setTimeout(() => {
                resizeComponent(width, height);
              }, 500);
          }
          if (data.key === 'onCloseAdsBuilder') {
            console.log('onCloseAdsBuilder', selectedAd);
          }
        }
      },
    );
    window.Wix.addEventListener(window.Wix.Events.SITE_SAVED, () => {
      const isSelectedNowsave =
        selectedAd && selectedAd.size === WIDGET_SIZE.responsive;
      const isadUnitByCompIdNowsave =
        adUnitByCompId && adUnitByCompId?.size === WIDGET_SIZE.responsive;
      console.log('@@SITE_SAVED', adUnitByCompId, selectedAd);
      if (
        !isMobile() &&
        (!adUnitByCompId ||
          (!selectedAd && isadUnitByCompIdNowsave) ||
          isSelectedNowsave)
      ) {
        console.log(
          '@@22SITE_SAVED',
          adUnitByCompId,
          selectedAd,
          isadUnitByCompIdNowsave,
          isSelectedNowsave,
        );
        setWixPublicData(
          `${compId}`,
          {
            width: window.innerWidth,
            height: window.innerHeight,
          },
          'COMPONENT',
        );
        dispatch(
          setDimensions({
            width: window.innerWidth,
            height: window.innerHeight,
          }),
        );
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, loadingStatus, loadingUpdateStatus, responsiveDimention]);
  useEventListener(window.Wix.Events.COMPONENT_DELETED, window.Wix, () => {
    console.log('COMPONENT_DELETED');
    dispatch(
      disconnectAllAdsByCompIdAsync({ instance: signedinstance, compId }),
    );
  });

  useLimitResize(adUnitByCompId, selectedAd, selectedAdtriggered);

  if (
    loadingStatus === 'idle' ||
    loadingStatus === 'pending' ||
    loadingUpdateStatus === 'pending'
  ) {
    return <Spinner diameter={50} isCentered={true} />;
  }
  return (
    <div className={classes.Wrapper}>
      <div className={classes.LogoAndTitleWrapper}>
        <div className={classes.Logo}>
          <AdsLogo />
        </div>
        <div>
          <Text tagName="h2" className={classes.TitleHeader}>
            {t('header', 'title')}
          </Text>
        </div>
      </div>
      <Text
        className={classes.TextHeader}
        typography={TextTypography.runningText}
      >
        {t('header', `text.${statusType}`)}
      </Text>
      <div className={classes.SectionNotificationWrapper}>
        <SectionNotification
          className={st(classes.root)}
          type={statusType}
          size="compact"
        >
          <SectionNotification.Icon
            className={st(classes.SectionNotificationIcon, {
              defaultType: statusType === SectionNotificationType.default,
              alertType: statusType === SectionNotificationType.alert,
              successType: statusType === SectionNotificationType.success,
            })}
            icon={
              sectionNotificationsIcons[
                sectionNotificationsTypes.indexOf(statusType)
              ]
            }
          />
          <SectionNotification.Text
            className={classes.SectionNotificationIconText}
          >
            {statusType === SectionNotificationType.success
              ? t('sectionNotification.adName.isConneted', '', {
                  adName: selectedAd?.ad_name
                    ? `${selectedAd?.ad_name}`
                    : `${adUnitByCompId?.ad_name}`,
                })
              : t(`sectionNotification.${statusType}`)}
          </SectionNotification.Text>
        </SectionNotification>
      </div>
      <>
        <IconButton
          className={st(classes.IconButton, {
            defaultType: statusType === SectionNotificationType.default,
            alertType: statusType === SectionNotificationType.alert,
            successType: statusType === SectionNotificationType.success,
          })}
          icon={
            sectionNotificationsIcons[
              sectionNotificationsTypes.indexOf(statusType)
            ]
          }
          theme={IconButtonThemes.Box}
        />
      </>
    </div>
  );
};

export default withTranslation()(withEnhancedStyleLoader(EditorWidgetContent));
